var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 2.5,
    stroke: "#E2E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2085 6.625L6.5835 8.25M17.4168 8.25L15.7918 6.625M8.75016 15.2917L7.66683 16.375M15.2502 15.2917L16.3335 16.375M12.0002 9.875V12.0417L13.0835 13.125M12.0002 16.375C13.1494 16.375 14.2517 15.9184 15.0643 15.1058C15.8769 14.2932 16.3335 13.1909 16.3335 12.0417C16.3335 10.8924 15.8769 9.7902 15.0643 8.97754C14.2517 8.16488 13.1494 7.70833 12.0002 7.70833C10.8509 7.70833 9.74869 8.16488 8.93604 8.97754C8.12337 9.7902 7.66683 10.8924 7.66683 12.0417C7.66683 13.1909 8.12337 14.2932 8.93604 15.1058C9.74869 15.9184 10.8509 16.375 12.0002 16.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3097126712bbc8ae53f6be4fb67c08f7.svg";
export { ForwardRef as ReactComponent };